import i18n from 'locales/i18next';

import { formatNumberI18n } from 'utils/i18n';

export const formatNumber = (stringOrNumber?: string | number | null) => formatNumberI18n(i18n.language)(Number(stringOrNumber ?? 0));
